module.exports = __webpack_public_path__ + "static/img/jpspot.a8ae552e.png";